// @ts-nocheck
class ProductWornBy extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    const useSlider = this.dataset.useSlider === 'true';
    if (useSlider) {
      this.initSwiper();
    }
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  initSwiper() {
    const swiperEl = this.querySelector('.product-worn-by__swiper');
    if (!swiperEl) return;

    this.swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 3.5,
      spaceBetween: 8,
      speed: 400,
      breakpoints: {
        768: {
          slidesPerView: 4.2,
        },
        990: {
          slidesPerView: 6.5,
        },
      },
      on: {
        init: (swiper) => this.updateArrowState(swiper),
        slideChange: (swiper) => this.updateArrowState(swiper),
      },
    });

    const prevArrow = this.querySelector('.product-worn-by__arrow--prev');
    const nextArrow = this.querySelector('.product-worn-by__arrow--next');

    if (prevArrow) {
      prevArrow.addEventListener('click', () => {
        if (this.swiperInstance) this.swiperInstance.slidePrev();
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', () => {
        if (this.swiperInstance) this.swiperInstance.slideNext();
      });
    }
  }

  updateArrowState(swiper) {
    const prevArrow = this.querySelector('.product-worn-by__arrow--prev');
    const nextArrow = this.querySelector('.product-worn-by__arrow--next');
    if (!prevArrow || !nextArrow) return;

    prevArrow.disabled = swiper.isBeginning;
    nextArrow.disabled = swiper.isEnd;
  }
}

if (!customElements.get('product-worn-by')) {
  customElements.define('product-worn-by', ProductWornBy);
}
